export const bundle = {
  pkg: "@apollo/client-react-streaming",
};

export const sourceSymbol = Symbol.for("apollo.source_package");
